import { forwardRef } from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import {
  TOOLTIP_ARROW_CLASS,
  TOOLTIP_CONTENT_CLASS,
  TOOLTIP_SIDE_OFFSET,
  type TTooltipContentElement,
  type TTooltipContentProps,
} from "@/ui/components/overlay/Tooltip/Tooltip.config";
import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib/utils";

export const TooltipContent = forwardRef<TTooltipContentElement, TTooltipContentProps>(
  (
    {
      children,
      className,
      sideOffset = TOOLTIP_SIDE_OFFSET,
      ...props
    },
    ref,
  ) => (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        data-component="TooltipContent"
        sideOffset={sideOffset}
        className={cn(
          "z-50 w-fit rounded-sys-sm px-3 py-1.5",
          "origin-[--radix-tooltip-content-transform-origin]",
          "animate-in fade-in-0 zoom-in-95",
          "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
          "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2",
          "data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          TOOLTIP_CONTENT_CLASS,
          className,
        )}
        {...props}
      >
        <TextBody
          tag="span"
          size={3}
          color="inverse"
          isResponsive={false}
          className="inline-flex flex-wrap items-center gap-1.5"
        >
          { children }
        </TextBody>
        <TooltipPrimitive.Arrow
          data-component="TooltipArrow"
          width={11}
          height={5}
          className={TOOLTIP_ARROW_CLASS}
        />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  ),
);

TooltipContent.displayName = TooltipPrimitive.Content.displayName;
